import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Pequeño delay para asegurar que el contenido lazy-loaded esté renderizado
            const scrollToHash = () => {
                const element = document.getElementById(hash.substring(1));
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                    return true;
                }
                return false;
            };
            
            // Intentar inmediatamente
            if (scrollToHash()) return;
            
            // Retry con múltiples intentos para manejar contenido lazy y navegación desde otras rutas
            let attempts = 0;
            const maxAttempts = 5;
            const intervalId = setInterval(() => {
                attempts++;
                if (scrollToHash() || attempts >= maxAttempts) {
                    clearInterval(intervalId);
                }
            }, 200);
            
            return () => clearInterval(intervalId);
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
